import { AvailableMFA, RECOVERY_OTP } from '../constants/mfa'

export const getSettings = ({ settings }) => settings
export const getRecoveryCodeError = ({ settings = {} }) =>
  settings.mfaSettings.recoveryOTPRegisterErrorCode
export const getShouldSetupMFA = ({ settings = {} }) =>
  settings.mfaSettings.mfaEnforced && !settings.mfaSettings.hasMFAEnabled
export const getMfaState = ({ settings: { mfaSettings = {} } = {} }) => ({
  enabledMFAMechanisms: mfaSettings.enabledMFAMechanisms,
  hasAllMFAEnabled:
    mfaSettings.enabledMFAMechanisms.length > 0 &&
    Object.keys(AvailableMFA).every(el =>
      mfaSettings.enabledMFAMechanisms.includes(el)
    ),
  mfaToRevoke: mfaSettings.mfaToRevoke,
  isLastMFAMechanism:
    mfaSettings.enabledMFAMechanisms.filter(mfa => mfa !== RECOVERY_OTP)
      .length === 1,
  isMFARevokeInProgress: mfaSettings.isMFARevokeInProgress,
  isSuccessfullyRevoked: mfaSettings.isSuccessfullyRevoked,
  revokeMFAErrorCode: mfaSettings.revokeMFAErrorCode
})
